export function deepEqual(a, b) {
  if (a === b) return true;

  if (typeof a !== "object" || typeof b !== "object" || a === null || b === null)
    return false;

  // Ignore undefined keys
  const keysA = Object.keys(a).filter(k => a[k] !== undefined);
  const keysB = Object.keys(b).filter(k => b[k] !== undefined);

  if (keysA.length !== keysB.length) return false;

  for (let key of keysA) {
    if (!keysB.includes(key)) return false;

    const valA = a[key];
    const valB = b[key];

    // Handle arrays directly
    if (Array.isArray(valA) && Array.isArray(valB)) {
      if (JSON.stringify(valA) !== JSON.stringify(valB)) return false;
      continue;
    }

    // Recurse
    if (!deepEqual(valA, valB)) return false;
  }

  return true;
}